import React, { useState } from "react";
import projects from "../../../data/data";
import "./ProjectWrap.css";

function ProjectMedia({ project }) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return <div className="project-media-placeholder">{project.name}</div>;
  }

  return (
    <div className="project-media">
      <img
        src={process.env.PUBLIC_URL + "/" + project.image}
        alt={`${project.name} platform`}
        loading="lazy"
        onError={() => setFailed(true)}
      />
    </div>
  );
}

function ProjectWrap() {
  return (
    <div className="project-area sec-mar">
      <div className="container">
        <div className="title-wrap wow animate fadeInUp" data-wow-delay="200ms">
          <div className="sec-title">
            <span>Our Flagship Platforms</span>
            <h2>Platforms We've Built</h2>
          </div>
        </div>

        {projects.map((project, index) => (
          <div
            key={project.id}
            id={project.slug}
            className={`project-card wow animate fadeInUp${
              index % 2 ? " reverse" : ""
            }`}
            data-wow-delay="200ms"
          >
            <div className="col-lg-7 p-0">
              <ProjectMedia project={project} />
            </div>

            <div className="col-lg-5">
              <div className="project-body">
                <div className="sec-title mb-0">
                  {project.tagline && (
                    <span className="project-tagline">{project.tagline}</span>
                  )}
                  <h2 className="project-title">{project.name}</h2>
                  <p className="project-desc">{project.description}</p>

                  {project.link && (
                    <div className="cmn-btn">
                      <div className="line-1" />
                      <div className="line-2" />
                      <a
                        href={project.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Explore Platform
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProjectWrap;
